import { Box, Flex, Icon, Text } from '@televet/kibble-ui';
import format from 'date-fns/format';
import FormAttachment from 'pages/Conversations/components/ChannelMessageOld/MessageBubble/Attachments/Form';
import React from 'react';
import Tooltip from 'shared/components/Tooltip';
import { AutomationRunActionFragment, ChannelViewClinicPetParentFragment } from 'shared/types/graphql';

interface IAutomationRunFormPromptProps {
  automationRunAction: AutomationRunActionFragment | undefined;
  actionIndex: number;
}

const AutomationRunFormPrompt = ({ automationRunAction, actionIndex }: IAutomationRunFormPromptProps): JSX.Element => {
  const sentTime = format(new Date(automationRunAction?.createdAt), 'h:mmaaa');
  return (
    <Box className="AutomationRun__PromptWrapper" px={6} py={4}>
      <Flex align="center" mt={4} className="AutomationRun__ChildAutomationStart">
        {actionIndex > 0 && (
          <>
            <Text fontWeight="bold" mr={2} as="span">
              Automation Sent{' '}
            </Text>
            <Text size="sm" as="span" color="text.subtle">
              {sentTime}
            </Text>
          </>
        )}
        {automationRunAction?.order === 1 && actionIndex !== 0 && (
          <Tooltip content={automationRunAction.automationAction?.workflowEventSetting?.name}>
            <Box>
              <Icon name="robot" />
            </Box>
          </Tooltip>
        )}
      </Flex>
      <Box whiteSpace="pre-wrap" className="AutomationRun__Question">
        <Text>{automationRunAction?.body}</Text>
      </Box>
      <Box
        className="AutomationRun__Answer"
        bg="background.primaryAlpha.hover"
        borderLeft="4px"
        borderLeftColor="border.brand"
        p={3}
        mt={6}
      >
        {automationRunAction && (
          <Box
            className="FormAttachment__Container"
            bg="background.default"
            border="1px"
            borderColor="border.default"
            borderRadius="md"
            p={3}
            w="max-content"
          >
            <FormAttachment
              entityId={automationRunAction.formSubmission?.id}
              clinicPetParentId={automationRunAction.formSubmission?.clinicPetParent?.id || ''}
              clinicPetParents={[
                automationRunAction.formSubmission?.clinicPetParent as ChannelViewClinicPetParentFragment,
              ]}
            />
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default AutomationRunFormPrompt;
